var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOtherHelp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.552 6.69166V0H16.5454V2.36805L12.8 0.0562743L0 7.95662V25.6H25.6V7.95662L23.552 6.69166ZM18.0814 1.536H22.0162V5.74455L18.0814 3.32795V1.536ZM24.064 24.064H1.536V8.81189L12.8 1.86149L24.064 8.81189V24.064Z",
    fill: "#009B3A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOtherHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/other_help.3f127583.svg";
export { ForwardRef as ReactComponent };